import { render } from "./SubmitDetailBtn.vue?vue&type=template&id=59a73171&scoped=true"
import script from "./SubmitDetailBtn.vue?vue&type=script&lang=js"
export * from "./SubmitDetailBtn.vue?vue&type=script&lang=js"

import "./SubmitDetailBtn.vue?vue&type=style&index=0&id=59a73171&lang=less&scoped=true"

import exportComponent from "/builds/maizhensheng/app-commonapply-v6/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-59a73171"]])

export default __exports__